if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const timestamp = Math.round(new Date().getTime() / 1000);  
        const formData = new FormData(this.form);
        const classcheck = this.querySelector('.addonproduct-qty');
        // ====== Bundle logic start
          if (classcheck){
           const bundleprice = document.querySelector('.addon-product-price');

                if (bundleprice) {
                  // get base bundle total
                  const bundleTotal = parseFloat(bundleprice.getAttribute('data-bundletotal')) || 0;

                  // get discount value (flat amount)
                  const discountdivget = document.querySelector('.bundlebox.active');
                  let Addddiscountget = 0;
                    if (discountdivget) {
                      Addddiscountget = parseFloat(discountdivget.getAttribute('data-discount')) || 0;
                    }
                  // apply flat discount
                    const finalPrice = bundleTotal - (bundleTotal * Addddiscountget / 100);
                    formData.append('properties[_bundle_price]', finalPrice);
                }

            formData.append('properties[_timestamp]', timestamp);
              const handlepass = document.querySelectorAll('.bundle-data-handle');
            let handles = [];
            let quantity_ = [];
            if (handlepass.length > 0) {
              handlepass.forEach(el => {
                const handle = el.getAttribute('data-handle');
                    const qtyInput = el.querySelector('.bundle-quantity-input');
                    const qty = qtyInput ? parseInt(qtyInput.value) || 0 : 0;


                  if (handle) {
                    handles.push(handle);
                    quantity_.push(`${handle}:${qty}`); // 👈 handle + qty format
                  }
              });

              // join into a single comma-separated string
              const handlesString = handles.join(", ");
                const quantityString = quantity_.join(", ");


              // pass into ONE property
              formData.append('properties[_product_handle]', handlesString);
                formData.append('properties[_product_qty]', quantityString);

            }
          }
          
          // ====== Bundle logic end
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {

              //  custom bundal code 
              if (classcheck){
                const bundalproductlist = document.querySelectorAll('.add-on-product');
                  if (bundalproductlist.length > 0) {
                    const bundalproduct = [];
                    bundalproductlist.forEach(bundalproductlists => {
                      const productIdEl = bundalproductlists.querySelector('.product-variant-id-bundle');
                        const productId = productIdEl ? productIdEl.value : null;
                      const qtyInput = bundalproductlists.querySelector('.bundle-quantity-input');
                    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 0;
                      console.log(productId, quantity);
                      if (productId) {
                        bundalproduct.push({
                          id: productId,
                          quantity: quantity,
                          properties: {
                            _timestamp: timestamp,
                            _bundle_product: true,
                          }
                        });
                      }
                    });
                    const ADDTOCART_OBJECT_MONTAGE = { items: bundalproduct };
                    console.log("ADDTOCART_OBJECT_MONTAGE", ADDTOCART_OBJECT_MONTAGE);
                    custom_addtocart_fun(ADDTOCART_OBJECT_MONTAGE, true);
                  }
              }
          //  custom bundal code end
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
